import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from "@angular/core";
import { DeviceCheckService } from "../../services/device-check.service";

export class TabContext {
  id: string;
  index: number;
  disabled: boolean;
  hidden: boolean;
  [key: string]: any;
}

@Component({
  selector: "app-survey-frame-tab-template",
  templateUrl: "./survey-frame-tab-template.component.html",
  styleUrls: ["./survey-frame-tab-template.component.scss"],
})
export class SurveyFrameTabTemplateComponent implements OnInit {
  @Input() contexts: TabContext[] = [];
  @Input() headerTemplate: TemplateRef<TabContext>;
  @Input() bodyTemplate: TemplateRef<TabContext>;
  @Input() headerWidth: string = "45%";
  @Input() bodyWidth: string = "45%";
  @Output() tabChange = new EventEmitter<string>();
  openTab: string;
  landscape: boolean;

  get currentContext() {
    return this.contexts.find((c) => c.id == this.openTab);
  }

  constructor(private _deviceCheckService: DeviceCheckService) {}

  ngOnInit(): void {
    this.landscape = !this._deviceCheckService.widthCheck(1000);
  }

  @HostListener("window:resize")
  onResize() {
    this.landscape = !this._deviceCheckService.widthCheck(1000);
  }

  onToggleDetail(id: string, force: boolean = false) {
    if (!force && this.contexts.find((c) => c.id == id)?.disabled) return;
    this.openTab = this.openTab == id ? undefined : id;
    this.tabChange.next(this.openTab);
  }
}
